import { Button, Grid, Typography } from "@material-ui/core";
import React from "react";
import "./Detail.css";
import { useHistory } from "react-router-dom";

const data = [
  {
    image: "re-html-css",
    name: "React Js",
    remark: "[Available to starts]",
    detail:
      " If you are starting from absolute ZERO, we got you! We are going to cover HTML, CSS, Modern Javascript (ReactJS) and a tonne of extra's that will propel you into the world of web development!",
  },
  {
    image: "redux",
    name: "Redux for Dummies",
    remark: "[Available to starts]",
    detail:
      " If there is one skill you NEED to land the frontend job, it's REDUX.",
  },
  {
    image: "mui-css",
    name: "Styling Mastery",
    remark: "[Available to starts]",
    detail:
      " If you need the responsive design & modern styling, Material-UI is the answer. In addition, Flexbox, CSS Grid and SO MUCH MORE to make your website the next big hit!",
  },
  {
    image: "fire-DB",
    name: "Styling Mastery",
    remark: "[Available to starts]",
    detail:
      " The world leader database are in HERE! Application and database are destiny couple. This is the unavoidable choice.",
  },
];

const cardData = [
  {
    name: "FULL-STACK (WEB) ADVANCED",
    priceName: "Discont 10%",
    oldPrice: "1,490,000 Kip",
    newPrice: "1,341,000 Kip",
    hours: "per 48 hours",
    topic: "DETAIL",
    detail1:
      "Grant Advanced topic knowledge “Distroy your knowledge barrier and maximize your skill” ",
    detail1_topic: "FRONTEND",
    detail1_content: "ReactJS, CSS & Material-UI (Advanced topic)",
    detail1_toppic2: "BACKEND",
    detail1_content2:
      "Web API on ASP.NET (C#)-VB2019 Authentication with JSON Web Token (JWT) security on Bearer and Oauth 2.0 authirization",
    detail1_topic3: "DATABASE",
    detail1_content3: "Firestore (NoSQL) & MS-SQL Server (Advanced topic)",
    detail2: "Create TWO practical projects",
    detail3: "Hosting project to server",
    detail4: "GOLD, support coaching after class",
    detail5: "GOLD, consultation on your application project",
    detail6: "NOTE: *Already Included beginner course",
    button: "Join now",
  },
  {
    name: "FULL-STACK (WEB) ADVANCED",
    priceName: "Discont 10%",
    oldPrice: "990,000 kip",
    newPrice: "891,000 kip",
    hours: "per 32 hours",
    topic: "DETAIL",
    detail1: "Grant fundamental knowledge from Zero to Max-basic skill",
    detail1_topic: "FRONTEND",
    detail1_content: "ReactJS, CSS & Material-UI (Advanced topic)",
    detail1_toppic2: "BACKEND",
    detail1_content2: "Web API on ASP.NET (C#)-VB2019",
    detail1_topic3: "DATABASE",
    detail1_content3: "Firestore (NoSQL) & MS-SQL Server",
    detail2: "Create ONE practical projects",
    detail3: "Support coaching after class",
    detail4: "GOLD, support coaching after class",
    detail5: "Consulting on your application project out of class",
    detail6: "",
    button: "Join now",
  },
  {
    name: "FULL STACK MODBILE APP (FLUTTER) FUNDAMENTAL",
    priceName: "",
    oldPrice: "",
    newPrice: "N/A kip",
    hours: "per xx hours",
    topic: "DETAIL",
    detail1: "Access to Mobile APP skill from Zero to Max-basic ",
    detail1_topic: "FRONTEND",
    detail1_content: "Dart Programming language",
    detail1_toppic2: "BACKEND",
    detail1_content2: "Web API on ASP.NET (C#)-VB2019",
    detail1_topic3: "DATABASE",
    detail1_content3: "Firestore (NoSQL) & MS-SQL Server",
    detail2: "Create one simple practical project",
    detail3: "Support coaching after class",
    detail4: "Consulting on your application project",
    detail5: "",
    detail6: "",
    button: "Join now",
  },
];

const detail5Data = [
  {
    topic: "Outline course",
    body1: "Full-stack outline for beginner (Day 1 - 8)",
    body2: "Full-stack outline for advanced (Day 1 -12)",
    body3: "Lesson Details",
    body4: "",
    body5: "",
    body6: "",
    body7: "",
  },
  {
    topic: "Lessons",
    body1: "ReactJS for beginner",
    body2: "ReactJS for Advanced",
    body3: "HTML",
    body4: "CSS",
    body5: "ADO.Net & Web API (C#)",
    body6: "MS-SQL Server",
    body7: "Google Cloud Firestore (NoSQL)",
  },
  {
    topic: "History courses",
    body1: "Course 1 (Beginner): 26-12-2020 to 16-01-2021",
    body2: "Course 2 (Beginner): 23-01-2021 to 14-02-2021",
    body3: "Course 3 (Advanced): 27-02-2021 to 13-03-2021",
    body4: "Course 4 (Beginner): 20-03-2021 to 25-04-2021",
    body5: "",
    body6: "",
    body7: "",
  },
];

function Detail() {
  const history = useHistory();
  return (
    <div>
      <div className="detail1">
        <Typography className="detail_text1">
          To Be Full-Stack Web-Application Programmer Are Very Simple.
        </Typography>
        <Typography className="detail_text2">
          Find programming languages that you are looking for them and Start to
          learn &
        </Typography>
        <Typography className="detail_text2">
          start to be a full-stack (web) application programmer.
        </Typography>
        <Button className="detail_button">More Detail</Button>
      </div>

      <div className="detail2">
        <Typography className="detail_text1">What's inside</Typography>
        <Typography className="detail_text2">
          The course will be released updated frequently.
        </Typography>
        <Typography className="detail_text2">
          In additional, the available course wll be announce 2 weeks before
          start!
        </Typography>
      </div>

      <div className="detail3">
        <Grid container spacing={9}>
          {data?.map((each) => (
            <Grid
              className="detail3_grid_item"
              item
              xs={6}
              md={4}
              lg={3}
              xl={2}
            >
              <img
                className="detail3_image"
                src={`/images/${each.image}.png`}
                alt="react"
              />
              <Typography className="detail3_text1">{each.name}</Typography>
              <Typography className="detail3_text2">{each.remark}</Typography>
              <Typography className="detail3_text3">{each.detail}</Typography>
            </Grid>
          ))}
        </Grid>
      </div>

      <div className="detail4">
        <Typography className="detail_text1">
          Do not hesitate to maximize your skill... Join the #RASA Programmer!
        </Typography>
        <Typography className="detail_text2">
          <span>HURRY UP! </span>
          Available only <span>15</span> students/course. Register will be
          closed
          <span>14-05-2021</span> <b>(Opened)</b>
        </Typography>
        <div>
          <Grid container spacing={2}>
            {cardData?.map((each) => (
              <Grid item xs={12} sm={6} md={4}>
                <div className="detail4_card">
                  <Typography
                    style={{
                      fontSize: "25px",
                      color: "#4902d9",
                      fontWeight: "700",
                    }}
                  >
                    {each.name}
                  </Typography>
                  <br />
                  <Typography
                    style={{
                      fontSize: "25px",
                      fontWeight: "700",
                      color: "#fe0000",
                      textShadow: "0px 0px 5px 1px gray",
                    }}
                  >
                    {each.priceName}
                  </Typography>
                  <del
                    style={{
                      fontSize: "25px",
                      fontWeight: "600",
                      color: "#454545",
                    }}
                  >
                    {each.oldPrice}
                  </del>
                  <Typography
                    style={{
                      fontSize: "40px",
                      fontWeight: "600",
                      color: "#454545",
                    }}
                  >
                    {each.newPrice}
                  </Typography>
                  <Typography style={{}}>{each.hours}</Typography>
                  <br />
                  <ins style={{ fontWeight: "700" }}>{each.topic}</ins>
                  <br />
                  <br />
                  <Typography style={{}}>{each.detail1}</Typography>
                  <br />
                  <Typography
                    style={{ fontWeight: "700", textAlign: "justify" }}
                  >
                    {each.detail1_topic}
                  </Typography>
                  <Typography style={{}}>{each.detail1_content}</Typography>
                  <Typography
                    style={{ fontWeight: "700", textAlign: "justify" }}
                  >
                    {each.detail1_toppic2}
                  </Typography>
                  <Typography style={{}}>{each.detail1_content2}</Typography>
                  <Typography
                    style={{ fontWeight: "700", textAlign: "justify" }}
                  >
                    {each.detail1_topic3}
                  </Typography>
                  <Typography style={{}}>{each.detail1_content3}</Typography>
                  <hr />
                  <Typography style={{ textAlign: "justify" }}>
                    {each.detail2}
                  </Typography>
                  <hr />
                  <Typography style={{ textAlign: "justify" }}>
                    {each.detail3}
                  </Typography>{" "}
                  <hr />
                  <Typography style={{ textAlign: "justify" }}>
                    {each.detail4}
                  </Typography>{" "}
                  <hr />
                  <Typography style={{ textAlign: "justify" }}>
                    {each.detail5}
                  </Typography>{" "}
                  <hr />
                  <Typography style={{ textAlign: "justify" }}>
                    {each.detail6}
                  </Typography>
                  <Button
                    variant="contained"
                    color="secondary"
                    style={{ margin: "20px 0px", width: "150px" }}
                    onClick={() => history.push("/register")}
                    // onClick={() => history.push("/contact")}
                  >
                    {each.button}
                  </Button>
                </div>
              </Grid>
            ))}
          </Grid>
        </div>
      </div>

      <div className="detail5">
        <Grid container spacing={9}>
          {detail5Data?.map((each) => (
            <Grid className="detail5_grid_text" item xs={12} md={6} lg={4}>
              <Typography className="detail5_text1">{each.topic}</Typography>
              <Typography className="detail5_text2">{each.body1}</Typography>
              <Typography className="detail5_text2">{each.body2}</Typography>
              <Typography className="detail5_text2">{each.body3}</Typography>
              <Typography className="detail5_text2">{each.body4}</Typography>
              <Typography className="detail5_text2">{each.body5}</Typography>
              <Typography className="detail5_text2">{each.body6}</Typography>
              <Typography className="detail5_text2">{each.body7}</Typography>
            </Grid>
          ))}
        </Grid>
      </div>
    </div>
  );
}

export default Detail;
